import { render, staticRenderFns } from "./vip_list.vue?vue&type=template&id=990bdb2c"
import script from "./vip_list.vue?vue&type=script&lang=ts"
export * from "./vip_list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports